var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-column-view-layout',{attrs:{"root":_vm.rootElement}})
}
var staticRenderFns = []

export { render, staticRenderFns }